import * as GBConst from "./GBConst";

export const getPyramidOptions = (title, packTable) => {
    let maleColStart = 1;
    let femaleColStart = 2;
    let startCol = 0;
    let maxY = 0;
    let mySeries = [
        {
            name: "Male",
            pointWidth: 7,
            data: [],
            totalPop: 0,
        },
        {
            name: "Female",
            pointWidth: 7,
            data: [],
            totalPop: 0,
        },
    ];

    const getTotalPopulation = (s) => {
        let sum = 0;

        switch (s) {
            case 1:
                startCol = maleColStart;
                break;
            case 2:
                startCol = femaleColStart;
                break;
            default:
                startCol = 0;
        }

        for (let a = 1; a <= 17; a++) {
            sum = sum + packTable.tableData.value[a][startCol];
        }

        return sum;
    };

    const getAgeGroupPopulation = (s, totalPop) => {
        let arr = [];
        let sum = 0;
        for (let a = 1; a <= 17; a++) {
            switch (s) {
                case 1:
                    startCol = maleColStart;
                    break;
                case 2:
                    startCol = femaleColStart;
                    break;
                default:
                    startCol = 0;
            }

            sum = sum + packTable.tableData.value[a][startCol];

            let population = sum;
            let percentage = (population / totalPop) * 100;

            // totalPop = Math.round(totalPop);
            // population = Math.round(sum);
            // percentage = (population / totalPop) * 100;

            arr.push({
                y: percentage,
                value: percentage,
                population: population,
            });

            sum = 0;
        }

        return arr;
    };

    const getData = () => {
        mySeries = [
            {
                name: "Male",
                pointWidth: 7,
                data: [],
                totalPop: 0,
            },
            {
                name: "Female",
                pointWidth: 7,
                data: [],
                totalPop: 0,
            },
        ];

        /* Get Total Population by 5-Year AgeGroup and Sex */
        mySeries[0].totalPop = getTotalPopulation(1);
        mySeries[1].totalPop = getTotalPopulation(2);

        /* Set Total Population and Percentage by AgeGroups */
        mySeries[0].data = getAgeGroupPopulation(1, mySeries[0].totalPop);
        mySeries[1].data = getAgeGroupPopulation(2, mySeries[1].totalPop);

        // Find the max y axis value.  For pyramids, its nice to have both sides have the same max value
        for (let i = 0; i < mySeries[0].data.length; i++) {
            if (mySeries[0].data[i].value > maxY) {
                maxY = mySeries[0].data[i].value;
            }
        }
        for (let i = 0; i < mySeries[1].data.length; i++) {
            if (mySeries[1].data[i].value > maxY) {
                maxY = mySeries[1].data[i].value;
            }
        }

        return mySeries;
    };

    if (typeof packTable !== "undefined") {
        mySeries = getData();
    }

    let options = {
        title: {
            text: title,
            style: {
                fontSize: "12px",
            },
        },
        exporting: {
            enabled: false,
        },
        legend: {
            enabled: false,
        },
        xAxis: {
            categories: [
                "0-4",
                "5-9",
                "10-14",
                "15-19",
                "20-24",
                "25-29",
                "30-34",
                "35-39",
                "40-44",
                "45-49",
                "50-54",
                "55-59",
                "60-64",
                "65-69",
                "70-74",
                "75-79",
                "80+",
            ],
        },
        yAxis: {
            min: -maxY,
            max: maxY,
        },
        series: mySeries,
    };

    return options;
};

export const getChartOptions = (title, packTable, chartType, row, col, lastRow, lastCol, reverse, stacked) => {
    let data;

    if (typeof packTable === "undefined") {
        packTable = {
            GBRowCount: 3,
            GBColCount: 3,
            tableData: {
                value: [
                    ["", "", ""],
                    ["", 1, 2],
                    ["", 3, 4],
                ],
            },
        };

        row = 1;
        col = 1;
        lastRow = 2;
        lastCol = 2;
    }

    data = packTable["tableData"].value;

    //let calcYear = DataStore.GBData.CalcYear[proj];
    //let finalYear = DataStore.GBData.FinalYear[proj];

    if (lastRow === null) {
        lastRow = packTable["GBRowCount"] - 1;
    }

    if (lastCol === null) {
        lastCol = packTable["GBColCount"] - 1;
    }

    //----------------------------------------------------------------------------
    //                              Validation
    //----------------------------------------------------------------------------

    let dataLastRow = data.length;
    let dataLastCol = data[0].length;

    if (dataLastRow <= lastRow) {
        console.error("function getChartOptions says dataLastRow <= lastRow");
        return;
    }

    if (dataLastCol <= lastCol) {
        console.error("function getChartOptions says dataLastCol <= lastCol");
        return;
    }

    //----------------------------------------------------------------------------

    let r;
    let c;

    let categories = [];
    let mySeries = [];

    if (reverse) {
        for (r = row; r <= lastRow; r++) {
            categories.push(data[r][col - 1]);
        }

        for (c = col; c <= lastCol; c++) {
            mySeries.push({ data: [], value: [], name: data[row - 1][c] });
        }

        let x = 0;
        for (c = col; c <= lastCol; c++) {
            for (r = row; r <= lastRow; r++) {
                mySeries[x].data.push(data[r][c]);
                mySeries[x].value.push(data[r][c]);
            }
            x++;
        }
    } else {
        for (c = col; c <= lastCol; c++) {
            categories.push(data[row - 1][c]);
        }

        for (r = row; r <= lastRow; r++) {
            try {
                mySeries.push({ data: [], value: [], name: data[r][col - 1] });
            } catch (e) {
                debugger;
            }
        }

        let x = 0;
        for (r = row; r <= lastRow; r++) {
            for (c = col; c <= lastCol; c++) {
                mySeries[x].data.push(data[r][c]);
                mySeries[x].value.push(data[r][c]);
            }
            x++;
        }
    }

    let isStacked = null;
    if (typeof stacked !== "undefined") {
        if (stacked) {
            isStacked = true;
        }
    }

    let chartTypeNEW;
    switch (chartType) {
        case "pyramid":
            chartTypeNEW = "bar";
            break;
        default:
            chartTypeNEW = chartType;
            break;
    }

    let options = {
        chart: {
            type: chartTypeNEW,
        },
        title: {
            text: title,
            style: {
                fontSize: "12px",
            },
        },
        exporting: {
            enabled: false,
        },
        credits: {
            text: "",
        },
        // exporting: {
        //     buttons: {
        //         contextButton: {
        //             symbol: 'download'
        //         }
        //     }
        // }
        tooltip: {
            enabled: true,
            shared: true,
            crosshairs: true,
            valueDecimals: 2,
            formatter: function() {
                let s = "<b>" + this.x + "</b>";

                const numberWithCommas = (x) => {
                    let parts = x.toString().split(".");
                    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    return parts.join(".");
                };

                this.points.forEach((item) => {
                    s += "<br/><b>" + item.series.name + "</b>: " + numberWithCommas(item.y.toFixed(2));
                    // s += '<br/><b>' + item.point.pName + '</b>: ' + (item.y).toFixed(2);
                    // s += '<br/><b>' + item.point.sName + '</b>: ' + (item.y).toFixed(2);
                    // s += '<br/><b>' + item.point.aName + '</b>: ' + (item.y).toFixed(2);
                    // s += '<br/><b>' + item.point.tName + '</b>: ' + (item.y).toFixed(2);
                });

                return s;
            },
        },
        legend: {
            enabled: false,
        },
        xAxis: {
            categories: categories,
        },
        plotOptions: {
            line: {
                marker: {
                    enabled: false,
                },
            },
            series: {
                stacking: isStacked,
            },
        },
        series: mySeries,
    };

    return options;
};

/* array.sort varies with the browser and can be slow. */

/* Swaps two elements in an array. */
export function swap(array, leftIdx, rightIdx) {
    let temp = array[leftIdx];
    array[leftIdx] = array[rightIdx];
    array[rightIdx] = temp;
}

export function partition(array, left, right) {
    let pivot = array[Math.floor((right + left) / 2)]; // middle element
    let i = left; // left pointer
    let j = right; // right pointer

    while (i <= j) {
        while (array[i] < pivot) {
            i++;
        }
        while (array[j] > pivot) {
            j--;
        }
        if (i <= j) {
            swap(array, i, j);
            i++;
            j--;
        }
    }

    return i;
}

export function quickSort(array, left, right) {
    /* Allows us to avoid passing left and right parameters when we first call quickSort. Make sure you
       pass left and right parameters otherwise. */
    if (typeof left === "undefined" || typeof right === "undefined") {
        left = 0;
        right = array.length - 1;
    }

    let idx;

    if (array.length > 1) {
        idx = partition(array, left, right);

        if (left < idx - 1) {
            quickSort(array, left, idx - 1);
        }

        if (idx < right) {
            quickSort(array, idx, right);
        }
    }

    return array;
}

export const createArray = (n, bounds, value) => {
    let len = bounds.shift();

    if (n > 1) {
        return Array(len).fill(createArray(n - 1, bounds, value));
    } else {
        return Array(len).fill(value);
    }
};

// stole from internet
export function decimalPlaces(num) {
    let match = ("" + num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);

    if (!match) {
        return 0;
    }

    return Math.max(
        0,
        // Number of digits right of decimal point.
        (match[1] ? match[1].length : 0) -
            // Adjust for scientific notation.
            (match[2] ? +match[2] : 0)
    );
}

// /**
//  * Uses canvas.measureText to compute and return the width of the given text of given font in pixels.
//  *
//  * @param {String} text The text to be rendered.
//  * @param {String} font The css font descriptor that text is to be rendered with (e.g. "bold 14px verdana").
//  *
//  * @see https://stackoverflow.com/questions/118241/calculate-text-width-with-javascript/21015393#21015393
//  */
// function getTextWidth(text, font) {
//     // re-use canvas object for better performance
//     var canvas = getTextWidth.canvas || (getTextWidth.canvas = document.createElement("canvas"));
//     var context = canvas.getContext("2d");
//     context.font = font;
//     var metrics = context.measureText(text);
//     return metrics.width;
// }

/* WARNING: Does not seem to work; values assigned to the array get copied over all the dimensions! */
// export const createArray = (n, bounds, value) => {
//
//     let len = bounds[0];
//     bounds.shift();
//
//     if (n > 1) {
//         return Array(len).fill( createArray(n-1, bounds, value) );
//     }
//     else {
//         return Array(len).fill( value );
//     }
// }

export function equalObj(object1, object2) {
    for (var property in object1) {
        if (!object2.hasOwnProperty(property)) {
            return false;
        }
    }

    return true;
}

export function getDelphiColorToHex(color) {
    if (color >= 0) {
        let hexString = color.toString(16);
        hexString = hexString.padStart(6, 0);

        let R = hexString.slice(-2);
        let G = hexString.slice(-4, -2);
        let B = hexString.slice(-6, -4);

        return "#" + (R + G + B);
    } else {
        return "";
    }
}

// not tested
export function getHexFromDelphiHexColor(hexStr) {
    let RGB;

    let R = hexStr.substr(5, 2);
    let G = hexStr.substr(3, 2);
    let B = hexStr.substr(1, 2);

    RGB = "#" + R + G + B;

    return RGB;
}

// not tested
export function getDelphiHexFromHexColor(hexStr) {
    let BGR;

    let R = hexStr.substr(1, 2);
    let G = hexStr.substr(3, 2);
    let B = hexStr.substr(5, 2);

    BGR = "#" + B + G + R;

    return BGR;
}

/* Converts a number in one base to base 10.  If the base is not specified, the base will be 16 (hex).
   Currently works up to base 16. */
export function toBase10(baseXStr, baseFrom) {
    let numBase10 = 0;

    if (typeof baseFrom === "undefined") {
        baseFrom = 16;
    }

    /* Remove #, if it exists. */
    let baseXStrNoHash = baseXStr.replace("#", "");

    /* Pos = position of current character in number, with the rightmost position being 0. */
    let pos = baseXStrNoHash.length - 1;
    let exp = 0;

    if (pos > -1) {
        while (pos !== -1) {
            /* Get the current character. */
            let n = baseXStrNoHash.substr(pos, 1);
            const nAsInt = parseInt(n);

            /* Convert n to a number if it's a letter. */
            if (isNaN(nAsInt)) {
                switch (n.toUpperCase()) {
                    case "A":
                        n = 10;
                        break;
                    case "B":
                        n = 11;
                        break;
                    case "C":
                        n = 12;
                        break;
                    case "D":
                        n = 13;
                        break;
                    case "E":
                        n = 14;
                        break;
                    case "F":
                        n = 15;
                        break;
                    default:
                        n = 1;
                        break;
                }
            }

            numBase10 += n * Math.pow(baseFrom, exp);

            pos--;
            exp++;
        }
    }

    return numBase10;
}

export function shouldComponentUpdateGB(currProps, nextProps, currState, nextState) {
    const nextPropsStr = JSON.stringify(nextProps);
    const currPropsStr = JSON.stringify(currProps);

    return nextPropsStr !== currPropsStr || nextState !== currState;
}

export function notEqual(a, b) {
    return a > b || a < b;
}

export function equal(a, b) {
    return !(a > b || a < b);
}

export function getSexStr(currID) {
    let sexStr = "";

    switch (currID) {
        case GBConst.sex.male:
            sexStr = "Male";
            break;

        case GBConst.sex.female:
            sexStr = "Female";
            break;

        default:
            break;
    }

    return sexStr;
}

export const callSuccessFn = (successFn) => {
    if (typeof successFn !== "undefined") {
        successFn();
    }
};
